import React, { ReactElement, useEffect, useState } from 'react'
import { ProgressBar } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import angry from '../../../../../assets/images/angry.svg'
import extremelyhappy from '../../../../../assets/images/extremely-happy.svg'
import happy from '../../../../../assets/images/happy.svg'
import neutral from '../../../../../assets/images/neutral.svg'
import sad from '../../../../../assets/images/sad.svg'
import { getRatingsSummary } from '../../../../../store/dashboard/actions'
import ExportReportShared from '../../../../../components/UI/ExportReportShared/ExportReportShared'

import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

export default function Ratings(props: any): ReactElement {
  const { t } = useTranslation('translation')
  const [loading, setLoading] = useState(false)
  const [filtersData, _setFiltersData] = useState({
    filter_from_date: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
    filter_to_date: dayjs().format('YYYY-MM-DD'),
  })
  const [ratingsData, setRatingsData] = useState(null)
  const dispatch = useDispatch()

  useEffect(() => {
    if (loading) {
      return
    }

    const fun = async () => {
      try {
        setLoading(true)
        const reportsData: any = await dispatch(getRatingsSummary(filtersData))
        setRatingsData(reportsData)
        setLoading(false)
      } catch (error: any) {
        setRatingsData({ ...(ratingsData || {}), ...error })
        setLoading(false)
      }
    }
    fun()
  }, [])

  const getImage = (id: number) => {
    let img = angry
    switch (id) {
      case 1:
        img = angry
        break
      case 2:
        img = sad
        break
      case 3:
        img = neutral
        break
      case 4:
        img = happy
        break
      case 5:
        img = extremelyhappy
        break
      default:
        img = neutral
        break
    }
    return img
  }
  const getRatingComponent = (id: number) => {
    const ratingData = ratingsData.ratingSummary.rows.find(
      (row: any) => row.rating === id,
    )
    return (
      <>
        <img src={getImage(id)} className="rate-smily" alt={t('rating')} />
        <ProgressBar now={ratingData ? ratingData.percentage.toFixed(2) : 0} />
        <span>{ratingData ? ratingData.percentage.toFixed(2) : 0}%</span>
      </>
    )
  }

  return (
    // graph-box
    <div className="tw-border tw-rounded-2xl tw-shadow-md tw-p-8">
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <h3 className="mb-0">{t('Virtual Assistant Rating')}</h3>
        <div className="d-flex flex-wrap sugested-next-ques">
          <ExportReportShared
            name={'rating-summary'}
            filtersData={filtersData}
            removedKeyFromObject="connection_ids"
          />
        </div>
      </div>
      {loading && (
        <div className="d-flex justify-content-center">
          <div className="spinner-border spinner-border-lg text-primary"></div>
        </div>
      )}

      {ratingsData && !loading && (
        <div className="row align-items-center">
          <div className="col-4 text-center">
            <div className="overall-rate">
              {ratingsData.ratingSummary.summary.rating_average
                ? ratingsData?.ratingSummary?.summary?.rating_average.toFixed(2)
                : 0}
            </div>

            {ratingsData?.ratingSummary?.summary?.rating_average && (
              <figure>
                <img
                  src={getImage(
                    Math.round(
                      ratingsData?.ratingSummary?.summary.rating_average,
                    ),
                  )}
                  alt={t('rating')}
                />
              </figure>
            )}
          </div>
          <div className="col-8">
            {Array.from(Array(5)).map((k: any, index: number) => {
              return (
                <div
                  className="my-3 d-flex align-items-center"
                  key={index + '_rating'}
                >
                  {getRatingComponent(index + 1)}
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}
